import { StyleStateEnum } from '../../../Common/PageBuilder/enums/style-state.enum';
import { ImageStyleModel } from '../../../Common/PageBuilder/models/image-style.model';
import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';

export class MonitoringImageStyleModel extends ImageStyleModel {
    constructor(apiModel?: any) {
        super(apiModel);
        if (apiModel) {
            this.setFromApiModel(apiModel);
            if (!this.styleState || this.styleState === StyleStateEnum.DEFAULT) {
                this.styleState = BriefingStyleStateEnum.BRIEFING_1;
            }
            if (!this.displayStyleState || this.displayStyleState === StyleStateEnum.DEFAULT) {
                this.displayStyleState = this.styleState;
            }
            if (
                (
                    !this.defaultReference ||
                    this.defaultReference === StyleStateEnum.DEFAULT
                ) &&
                typeof this.styleState === 'string'
            ) {
                // Legacy data may not have default reference set, if the styleState is custom and there's no default reference, the default reference
                // should be BRIEFING_1 because it must have been created back when there was only one default
                this.defaultReference = this.styleState !== StyleStateEnum.CUSTOM ? this.styleState as string : BriefingStyleStateEnum.BRIEFING_1;
            }
        }
    }
}
